import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import {
  Notification_Target_States_Enum,
  useCreateNotificationTargetsMutation,
  useLazyLineNotificationServicesQuery,
} from '@/app/api/generated';
import { CheckModal } from '@/components/Elements/CheckModal/CheckModal';
import { REACT_APP_CUCON_API_DOMAIN } from '@/config';
import themeTokens from '@/config/theme-tokens.js';
import {
  PREV_PATH,
  NOTIFICATION_CONDITION_ID,
  getToken,
} from '@/utils/storage';

const MODALS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};
const brandBackgroundColor = themeTokens.color.brand.background;

export const NotificationSetting = () => {
  const navigate = useNavigate();
  const [createNotificationTargets] = useCreateNotificationTargetsMutation();
  const [fetchLineNotificationServices] =
    useLazyLineNotificationServicesQuery();
  const [openModalName, setOpenModalName] = useState<string | null>(null);
  const { servicesId } = useParams();
  const [searchParams] = useSearchParams();
  const prevPath = getToken(PREV_PATH);

  useEffect(() => {
    const params = {
      code: searchParams.get('code'),
      state: searchParams.get('state'),
      error: searchParams.get('error'),
      errorDescription: searchParams.get('error_description'),
    };

    // エラーがなければ設定を続ける
    if (
      params.error === null &&
      params.code !== null &&
      params.state !== null
    ) {
      // 通知先登録API用のAPIキーを取得する
      fetchLineNotificationServices()
        .unwrap()
        .then((result) => {
          const apiKey =
            result.notificationServices[0].notificationSettings[0].settings[
              'api-key'
            ];
          const apiUrl = `${REACT_APP_CUCON_API_DOMAIN}/notification/${servicesId}/setting`;

          fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'api-Key': apiKey,
            },
            credentials: 'include',
            body: JSON.stringify({
              code: params.code,
              state: params.state,
            }),
          })
            .then(async (result) => {
              const data = await result.json();
              if (data.state === 'success') {
                const notificationUserId = data.user_id;
                const notificationConditionId = getToken(
                  NOTIFICATION_CONDITION_ID
                );

                // 通知設定を行う
                await createNotificationTargets({
                  notificationUserId,
                  notificationConditionId,
                  state: Notification_Target_States_Enum.Enabled,
                })
                  .then(() => {
                    //
                  })
                  .catch((error) => {
                    console.error(error);
                    setOpenModalName(MODALS.FAILURE);
                  })
                  .finally(() => {
                    setOpenModalName(MODALS.SUCCESS);
                  });
              } else {
                console.error(data);
                setOpenModalName(MODALS.FAILURE);
              }
            })
            .catch((reason) => {
              console.error(reason);
              setOpenModalName(MODALS.FAILURE);
            });
        })
        .catch((reason) => {
          console.error(reason);
          setOpenModalName(MODALS.FAILURE);
        });
    } else {
      // ユーザーキャンセル？
      if (params.errorDescription === 'user canceled') {
        // ユーザーのキャンセルであれば、そのまま前のページを開く
        navigate(prevPath);
      } else {
        console.error(params.error);
        setOpenModalName(MODALS.FAILURE);
      }
    }
  }, [
    createNotificationTargets,
    fetchLineNotificationServices,
    navigate,
    prevPath,
    searchParams,
    servicesId,
  ]);

  const handleExecute = () => {
    navigate(prevPath);
  };

  return (
    <>
      <div
        className={
          'absolute left-[5px] top-[5px] inline-block items-center rounded-[4px] p-[2px]'
        }
      >
        <div className="pointer-events-none fixed right-0 z-[100] flex w-full flex-col items-center justify-center text-center">
          {openModalName === MODALS.SUCCESS && (
            <CheckModal
              title={'完了'}
              description={'通知設定が完了しました'}
              backgroundColor={brandBackgroundColor}
              handleExecute={handleExecute}
              executeButtonName="戻る"
            />
          )}
          {openModalName === MODALS.FAILURE && (
            <CheckModal
              title={'失敗'}
              description={'通知設定が失敗しました'}
              backgroundColor={brandBackgroundColor}
              handleExecute={handleExecute}
              executeButtonName="戻る"
            />
          )}
        </div>
      </div>
    </>
  );
};
